module.exports = __webpack_public_path__ + "img/1313110704.bf0c69ee.jpg";